//@flow
import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Translate } from "@quantum/i18n";
import { type Id, ID_PERIODO_MES_ESPECIFICO } from "../../../../../model";
import {
  type State,
  type ActionCreator,
  getPeriodosSelecionados,
  getCompetenciaSelecionada,
  selecionarCompetencia,
  selecionarPrimeiraCompetencia,
} from "../../../../../state";
import SelecaoMesAnoComposto from "./SelecaoMesAnoComposto";

type Props = {
  periodosSelecionados: ?Array<Id>,
  competenciaSelecionada: string,
  selecionarCompetencia: ActionCreator,
  selecionarPrimeiraCompetencia: ActionCreator,
};

function SelecaoCompetencia({
  periodosSelecionados,
  competenciaSelecionada,
  selecionarCompetencia,
  selecionarPrimeiraCompetencia,
}: Props) {
  const exibir: boolean =
    periodosSelecionados != null &&
    periodosSelecionados.length === 1 &&
    periodosSelecionados[0] === ID_PERIODO_MES_ESPECIFICO;

  useEffect(() => {
    if (exibir && !competenciaSelecionada) {
      selecionarPrimeiraCompetencia();
    }
  }, [competenciaSelecionada, exibir, selecionarPrimeiraCompetencia]);

  if (!exibir) {
    return null;
  }

  function handleCompetenciaSelecionada(competencia) {
    selecionarCompetencia(competencia);
  }

  return (
    <div className="ConfiguracaoMedida">
      <label className="ConfiguracaoMedida__label">
        <Translate>maiusculas.competencia</Translate>
      </label>
      <SelecaoMesAnoComposto
        mesEAnoCompostoSelecionado={competenciaSelecionada}
        onChange={handleCompetenciaSelecionada}
      />
    </div>
  );
}

export default connect(
  (state: State) => ({
    periodosSelecionados: getPeriodosSelecionados(state),
    competenciaSelecionada: getCompetenciaSelecionada(state),
  }),
  { selecionarCompetencia, selecionarPrimeiraCompetencia }
)(SelecaoCompetencia);
